import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css'; // Ensure we have some styles, or rely on App.css
import InstitutionDetails from './InstitutionDetails';
import ProjectStatus from './ProjectStatus';
import NewConstruction from './NewConstruction';
import Renovation from './Renovation';
import Equipment from './Equipment';
import SoftComponent from './SoftComponent';
import ProjectOutcome from './ProjectOutcome';
import "../index.css";


export default function RusaTabs() {
    const username = sessionStorage.getItem('user_name');
    console.log("username", username);
    const handleTabChange = (index) => {
        // console.log("Tab Changed to:", index);
    };

    return (
        <div>

            {/* <CommonFormHeading heading="Status Submission Form" /> */}
            <Tabs onSelect={(index) => handleTabChange(index)} className='status-tabcontainer'>
                <TabList className="tabs-container affl-tabcontainer status-tabcontainer">
                    <Tab className="tab"><span><img src='../images/tabs-institution-details.svg' /></span>Institution Details</Tab>
                    <Tab className="tab"><span><img src='../images/tabs-status-project.svg' /></span>Status of the Project</Tab>
                    <Tab className="tab"><span><img src='../images/tabs-new-construction.svg' /></span>New Construction</Tab>
                    <Tab className="tab"><span><img src='../images/tabs-renovation.svg' /></span>Renovation</Tab>
                    <Tab className="tab"><span><img src='../images/tabs-equipment.svg' /></span>Equipment</Tab>
                    <Tab className="tab"><span><img src='../images/tabs-soft-component.svg' /></span>Soft Component</Tab>
                    <Tab className="tab"><span><img src='../images/tabs-outcome-project.svg' /></span>Outcome of the Project</Tab>
                </TabList>

                <TabPanel><InstitutionDetails /></TabPanel>
                <TabPanel><ProjectStatus /></TabPanel>
                <TabPanel><NewConstruction /></TabPanel>
                <TabPanel><Renovation /></TabPanel>
                <TabPanel><Equipment /></TabPanel>
                <TabPanel><SoftComponent /></TabPanel>
                <TabPanel><ProjectOutcome /></TabPanel>
            </Tabs>
        </div >
    );
}
